import React from 'react';
export function Footer() {
  return <footer className="bg-black text-zinc-400 py-12 border-t border-amber-900/40" data-id="element-99">
      <div className="container mx-auto px-4 text-center max-w-2xl" data-id="element-100">
        <h4 className="text-white font-bold text-xl mb-4" data-id="element-101">
          🔨 MEGAPACK HERRERO ARGENTINO™
        </h4>

        <div className="flex flex-wrap justify-center gap-4 text-sm mb-8" data-id="element-102">
          <a href="mailto:contacto@herreroargentino.com.ar" className="hover:text-amber-400 transition-colors" data-id="element-103">
            📧 contacto@herreroargentino.com.ar
          </a>
          <span className="hidden sm:inline" data-id="element-104">·</span>
          <span className="hover:text-amber-400 transition-colors" data-id="element-105">
            📱 @herreroargentino.ar
          </span>
        </div>

        <div className="text-xs text-zinc-600 border-t border-zinc-800 pt-8 space-y-3" data-id="element-106">
          <p data-id="element-107">
            © MEGAPACK HERRERO ARGENTINO™ 2026 — Todos los derechos
            reservados.
          </p>
          <p className="italic text-amber-300/80" data-id="element-108">
            🔨🇦🇷 "La próxima vez que llegue un trabajo difícil, vas a saber
            exactamente cómo hacerlo — y cuánto cobrar."
          </p>
        </div>
      </div>
    </footer>;
}